export var Permission;
(function (Permission) {
    Permission[Permission["ManagePhraseTriggers"] = 1] = "ManagePhraseTriggers";
    Permission[Permission["ManageUsers"] = 2] = "ManageUsers";
    Permission[Permission["ViewAgent"] = 3] = "ViewAgent";
    Permission[Permission["ViewAnomalies"] = 4] = "ViewAnomalies";
    Permission[Permission["ViewExplore"] = 5] = "ViewExplore";
    Permission[Permission["ViewLive"] = 6] = "ViewLive";
    Permission[Permission["ManageWritingIssues"] = 7] = "ManageWritingIssues";
    Permission[Permission["ManageInteractionTags"] = 8] = "ManageInteractionTags";
    Permission[Permission["ViewCustomReports"] = 9] = "ViewCustomReports";
    Permission[Permission["ManageAgentTags"] = 11] = "ManageAgentTags";
})(Permission || (Permission = {}));
//# sourceMappingURL=permissions.js.map